// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tree-catalog"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 5L13 5M21 12H13M21 19H13","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M3 3H9V9H3V3Z M3 15H9V21H3V15Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const TreeCatalogIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tree-catalog',
    ref,
    icon: element,
  },
));

TreeCatalogIcon.displayName = 'TreeCatalogIcon';

export default TreeCatalogIcon;
